module.exports = __webpack_public_path__ + "static/media/sipec01.3cd5bb8f.png";